import { createSelector } from 'reselect'
import { selectFeatureCalloutExpired } from 'selectors/app'
import { emptyObj } from 'util/objects'
import {
  HIDE_CANNED_REPLY_ACTIONS_CALLOUT,
  HIDE_RULE_TRIGGERS_CALLOUT,
} from './flagNames'

function selectBase(state) {
  return state.flags || emptyObj
}

export const selectIsFetchingFlags = createSelector(
  selectBase,
  flags => flags.fetching
)

const selectByName = createSelector(selectBase, flags => flags.byName)

// NOTE (jscheel): There are three possible states of a flag:
// 1. true      - The flag exists on the agent
// 2. false     - The flag was not found on the agent
// 3. undefined - Flag is still loading, you should _not_ depend on it yet
export const selectFlag = createSelector(
  selectIsFetchingFlags,
  selectByName,
  (fetching, byName) => {
    if (fetching) {
      return () => undefined
    }
    return name => !!byName[name]
  }
)

export const selectShouldHideNewForCannedReply = state =>
  selectFeatureCalloutExpired(state, '2023-03-14T00:00:00') ||
  selectFlag(state)(HIDE_CANNED_REPLY_ACTIONS_CALLOUT) !== false

export const selectShouldHideNewRule = state =>
  selectFeatureCalloutExpired(state, '2023-03-14T00:00:00') ||
  selectFlag(state)(HIDE_RULE_TRIGGERS_CALLOUT) !== false
